module.exports = "/_next/static/resources/single-74a5ec876abfab5de1c484251b6af066.jpg";